import { Container } from "react-bootstrap";

export const SomethingBroke = () => {
  return (
    <>
      <Container className='p-0 mb-5 permit app-container err-component mt-5'>
        <div>
          <div className='text-center'>
            <h1>Oops! Something Went Wrong</h1>
            <p>
              Sorry, this is not working properly. We now know about this mistake and are working to fix it.
              <br />
              In the meantime, here is what you can do.
            </p>
            <ul className=''>
              <li>Refresh the page</li>
              <li>Try again in 30 minutes</li>
              <li>Email us at UCFM@utahcounty.gov and tell us what happend</li>
            </ul>
            <button
              onClick={() => {
                window.location.replace("https://codev.utahcounty.gov/fire-marshal");
              }}
              type='button'
              className='btn btn-outline-danger'
            >
              Return Home
            </button>
          </div>
        </div>
      </Container>
    </>
  );
};
